import { TITLE_PREFIX, PO_INDEX_ROUTE } from './consts';

export default () => ({
    label: `${TITLE_PREFIX}s`,
    link: PO_INDEX_ROUTE,
    icon: 'purchase',
    permission: 'purchase orders.index',
    order: 40,
});
